import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { Loading, LoadingButton } from "../Common/Loading";
import RelatedProducts from "./RelatedProducts";
import { Zoom, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { BASE_URL } from "../../config";

import "swiper/css";
import "swiper/css/zoom";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import { useSelector } from "react-redux";
import store from "../../store/store";
import { isEmpty } from "lodash";

const Product = () => {
  const lang = useSelector((state) => state.lang);
  const currency = useSelector((state) => state.currency);
  const translations = useSelector((state) => state.translations);
  const getWord = (val) => {
    console.log(lang);
    const value = val.trim().toLowerCase();
    const word = !isEmpty(translations[lang][value])
      ? translations[lang][value]
      : val;
    return word;
  };
  const dispPrice = (val) => {
    val =
      currency.currency === "KWD" || currency.currency === "BHD"
        ? (currency.price * val).toFixed(3)
        : (currency.price * val).toFixed(2);
    return `${currency.currency} ${val}`;
  };
  const { id } = useParams();
  const [data, setData] = useState({
    product: "",
    related: "",
  });
  const { product, related } = data;
  const [quantity, setQuantity] = useState(1);

  // Function to handle increment
  const maxQuantity = 10;

  const increment = () => {
    if (quantity < maxQuantity) {
      setQuantity((prevQuantity) => prevQuantity + 1);
    }
  };

  // Function to handle decrement, ensuring quantity doesn't go below 1
  const decrement = () => {
    if (quantity > 1) {
      setQuantity((prevQuantity) => prevQuantity - 1);
    }
  };

  useEffect(() => {
    const getData = async () => {
      await axios
        .get(`${BASE_URL}/products/info/${id}`)
        .then((response) => {
          setData({
            ...data,
            product: response.data.product,
            related: response.data.related,
          });
        })
        .catch((error) => {
          // console.log(error);
        });
    };
    getData();
  }, [id]);

  if (product.length === 0) {
    return (
      <>
        <Loading />
      </>
    );
  }
  return (
    <>
      <section className="flat-spacing-4 pt_0">
        <div className="tf-main-product">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <Swiper
                  zoom={true}
                  modules={[Zoom, Navigation]}
                  navigation
                  spaceBetween={10}
                  slidesPerView={1}
                  className="mySwiper"
                >
                  {product?.images?.map((img, idx) => (
                    <SwiperSlide key={idx}>
                      <div className="swiper-zoom-container">
                        <img src={img} alt={`Slide ${idx}`} />
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>

              <div className="col-md-6">
                <div className="tf-product-info-wrap sticky-top">
                  <div className="tf-zoom-main"></div>
                  <div className="tf-product-info-list other-image-zoom">
                    <div className="tf-product-info-title">
                      <h5>
                        {lang === "ar" ? product.title_ar : product.title}
                      </h5>
                      <p>{lang === "ar" ? product.about_ar : product.about}</p>
                    </div>
                    <div className="tf-product-info-price">
                      {product.discount > 0 ? (
                        <>
                          <div className="price-on-sale" id="price">
                            {dispPrice(product.discount)}
                          </div>
                          <div className="compare-at-price">
                            {dispPrice(product.price)}
                          </div>
                          <div className="badges-on-sale">
                            <span>
                              {(
                                ((product.price - product.discount) /
                                  product.price) *
                                100
                              ).toFixed()}
                            </span>
                            % OFF
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="price-on-sale" id="price">
                            {dispPrice(product.price)}
                          </div>
                        </>
                      )}
                    </div>
                    {product.sizes.length > 0 ? (
                      <>
                        <div className="variant-picker-item" id="color">
                          <div className="variant-picker-label">
                            {getWord("Color")} *
                          </div>
                          <div className="variant-picker-values">
                            {product.sizes.map((color, idx) => (
                              <div key={idx}>
                                <input
                                  type="radio"
                                  id={`color-${color.id}`}
                                  name="color"
                                  value={color.id}
                                  defaultChecked={idx === 0}
                                />
                                <label
                                  className="style-text"
                                  htmlFor={`color-${color.id}`}
                                  data-value={
                                    lang === "ar" ? color.title_ar : color.title
                                  }
                                >
                                  <p>
                                    {lang === "ar"
                                      ? color.title_ar
                                      : color.title}
                                  </p>
                                </label>
                              </div>
                            ))}
                          </div>
                        </div>
                        <div className="variant-picker-item">
                          <div className="d-flex justify-content-between align-items-center">
                            <div className="variant-picker-label">
                              {getWord("Size")} *
                            </div>
                          </div>
                          <div className="variant-picker-values" id="sizes">
                            {product.sizes.map((color) =>
                              color.list.map((size, idx) => (
                                <div key={idx}>
                                  <input
                                    key={idx}
                                    type="radio"
                                    id={`size-${size.id}`}
                                    name="size"
                                    data-qty={size.quantity}
                                    value={size.id}
                                    defaultChecked={idx === 0}
                                  />
                                  <label
                                    className="style-text"
                                    htmlFor={`size-${size.id}`}
                                    data-value={
                                      lang === "ar" ? size.title_ar : size.title
                                    }
                                  >
                                    <p>
                                      {lang === "ar"
                                        ? size.title_ar
                                        : size.title}
                                    </p>
                                  </label>
                                </div>
                              ))
                            )}
                          </div>
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                    {product.addons.length > 0
                      ? product.addons.map((addon, idc) => (
                          <div
                            key={idc}
                            className="variant-picker-item"
                            id="color"
                          >
                            <div className="variant-picker-label">
                              {lang === "ar" ? addon.title_ar : addon.title}
                              {addon.required === "1" ? " *" : ""}
                            </div>
                            <div className="variant-picker-values">
                              {addon.items.map((item, idx) => (
                                <div key={idx}>
                                  <input
                                    type="radio"
                                    id={`addon-${item.id}`}
                                    name={`addon-${addon.id}`}
                                    value={item.id}
                                  />
                                  <label
                                    className="style-text"
                                    htmlFor={`addon-${item.id}`}
                                    data-value={
                                      lang === "ar" ? item.title_ar : item.title
                                    }
                                  >
                                    <p>
                                      {lang === "ar"
                                        ? item.title_ar
                                        : item.title}
                                    </p>
                                  </label>
                                </div>
                              ))}
                            </div>
                          </div>
                        ))
                      : ""}
                    {product.fields.length > 0
                      ? product.fields.map((field, idx) => (
                          <div key={idx}>
                            <div className="tf-product-item-property">
                              <div className="tf-field">
                                <input
                                  className="tf-field-input tf-input"
                                  type="text"
                                  id={`field-${field.id}`}
                                  name={`field-${field.id}`}
                                  placeholder=""
                                />
                                <label className="tf-field-label">
                                  {lang === "ar" ? field.title_ar : field.title}
                                  {field.required === "1" ? " *" : ""}
                                </label>
                              </div>
                            </div>
                          </div>
                        ))
                      : ""}
                    <div className="tf-product-info-buy-button" id="cart_info">
                      <div className="tf-product-info-quantity mb-4">
                        <div className="quantity-title fw-6">
                          {getWord("Quantity")}
                        </div>
                        <div className="wg-quantity qty-5">
                          <span className="btn-quantity" onClick={decrement}>
                            -
                          </span>
                          <input
                            type="text"
                            id="qty"
                            name="quantity"
                            value={quantity}
                            readOnly
                          />
                          <span className="btn-quantity" onClick={increment}>
                            +
                          </span>
                        </div>
                      </div>
                      <button
                        type="submit"
                        id="pro_submit"
                        className="tf-btn btn-fill justify-content-center fw-6 fs-16 flex-grow-1 animate-hover-btn w-100"
                      >
                        {/* {loading ? <LoadingButton></LoadingButton> : ""} */}
                        <span>{getWord("ADD TO CART")}</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {related.length > 0 ? <RelatedProducts data={related} /> : ""}
    </>
  );
};

export default Product;
